import { DecimalPipe, registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeCl from '@angular/common/locales/es';
import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { ActionSheet } from '@awesome-cordova-plugins/action-sheet/ngx';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { Badge } from '@awesome-cordova-plugins/badge/ngx';
import { BrowserTab } from '@awesome-cordova-plugins/browser-tab/ngx';
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { Clipboard } from '@awesome-cordova-plugins/clipboard/ngx';

import { Facebook } from '@awesome-cordova-plugins/facebook/ngx';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { FileTransfer } from '@awesome-cordova-plugins/file-transfer/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { FingerprintAIO } from '@awesome-cordova-plugins/fingerprint-aio/ngx';
import { FirebaseX } from '@awesome-cordova-plugins/firebase-x/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Intercom } from '@awesome-cordova-plugins/intercom/ngx';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { TapticEngine } from '@awesome-cordova-plugins/taptic-engine/ngx';
import { ThemeDetection } from '@awesome-cordova-plugins/theme-detection/ngx';
import { Vibration } from '@awesome-cordova-plugins/vibration/ngx';
import { Smartlook } from '@ionic-native/smartlook/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage';
import { NgCircleProgressModule } from 'ng-circle-progress';

import { SideMenuModule } from '@components/side-menu/side-menu.module';
import {
  ModalSecurityLendingActivationModule,
} from '@pages/private/home/modal-security-lending-activation/modal-security-lending-activation.page.module';
import { DeepLinksService } from '@services/deeplinks/deeplinks.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomErrorHandler } from './services/custom-error-handler/custom-error-handler';
import { PushNotificationsService } from './services/push-notifications/push-notifications.service';

registerLocaleData(localeCl);

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    HttpClientModule,
    NgCircleProgressModule.forRoot(),
    AppRoutingModule,
    SideMenuModule,
    ModalSecurityLendingActivationModule,
  ],
  providers: [
    AppVersion,
    Badge,
    Intercom,
    Facebook,
    // tslint:disable-next-line: deprecation
    FileTransfer,
    // tslint:disable-next-line: deprecation
    Smartlook,
    ThemeDetection,
    InAppBrowser,
    BrowserTab,
    StatusBar,
    SplashScreen,
    Keyboard,
    ActionSheet,
    File,
    Camera,
    FileOpener,
    Clipboard,
    SocialSharing,
    Vibration,
    TapticEngine,
    FirebaseX,
    PushNotificationsService,
    DeepLinksService,
    FingerprintAIO,
    CustomErrorHandler,
    DecimalPipe,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: ErrorHandler, useClass: CustomErrorHandler},
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
